var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2810_8085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.670315 1.71707C1.22101 2.01069 8.84948 6.08103 9.13386 6.23121C9.41823 6.38362 9.78612 6.45534 10.1563 6.45534C10.5264 6.45534 10.8943 6.38138 11.1787 6.23121C11.463 6.07879 19.0915 2.01069 19.6422 1.71707C20.1929 1.42345 20.7142 0.5 19.7031 0.5H0.609377C-0.401734 0.5 0.11962 1.42345 0.670315 1.71707ZM19.8747 3.95845C19.2495 4.28345 11.5623 8.27534 11.1787 8.47259C10.795 8.67207 10.5264 8.69672 10.1563 8.69672C9.78612 8.69672 9.51754 8.66983 9.13386 8.47259C8.75018 8.2731 1.06302 4.28121 0.437849 3.95845C-0.0045121 3.72983 1.80558e-06 3.99655 1.80558e-06 4.205C1.80558e-06 4.41121 1.80558e-06 12.4264 1.80558e-06 12.4264C1.80558e-06 12.8948 0.62969 13.5 1.11945 13.5H19.1931C19.6828 13.5 20.3125 12.8948 20.3125 12.4264C20.3125 12.4264 20.3125 4.41121 20.3125 4.205C20.3125 3.99655 20.317 3.72983 19.8747 3.95845Z",
    fill: "#266BEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2810_8085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
export default SvgEmail;